/**
 * Single source of truth for Google OAuth scopes used when installing the Workspace admin integration.
 * API verifies tokens against these URLs (see apps/api createGoogleIntegration).
 *
 * OpenID shorthands `email` / `profile` are still accepted by Google but are aliases of the userinfo.*
 * URLs below; requesting only the URL form avoids duplicate scope entries and matches the token check.
 */
export var GOOGLE_WORKSPACE_INTEGRATION_SCOPE_URLS = [
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/admin.directory.user.readonly',
    'https://www.googleapis.com/auth/admin.directory.domain.readonly',
    'https://www.googleapis.com/auth/admin.reports.audit.readonly',
    'https://www.googleapis.com/auth/admin.reports.usage.readonly',
    'https://www.googleapis.com/auth/admin.directory.customer.readonly',
    'https://www.googleapis.com/auth/admin.directory.orgunit.readonly'
];
/** Space-separated scopes for `useGoogleLogin` (auth-code flow). */
export var GOOGLE_WORKSPACE_INTEGRATION_OAUTH_SCOPE = GOOGLE_WORKSPACE_INTEGRATION_SCOPE_URLS.join(' ');
